const selectPalette = (tokens) => {
    return {
        container: {
            padding: tokens.textfieldPadding,
            border: {
                // TODO: ask Ann about rednaming to border radius
                radius: tokens.textfieldRadius,
                width: tokens.textfieldBorderWidth,
                default: tokens.textfieldColorBorderDefault,
                hover: tokens.textfieldColorBorderHover,
                focus: tokens.textfieldColorBorderFocus,
                disabled: tokens.textfieldColorBorderDisabled,
                error: tokens.textfieldColorBorderError
            },
            background: {
                default: tokens.textfieldColorBgDefault,
                hover: tokens.textfieldColorBgHover,
                focus: tokens.textfieldColorBgFocus,
                disabled: tokens.textfieldColorBgDisabled,
                error: tokens.textfieldColorBgError
            },
            text: {
                default: tokens.textfieldColorTextEnteredDefault,
                disabled: tokens.textfieldColorTextEnteredDisabled,
                error: tokens.textfieldColorTextLabelError,
                label: {
                    default: tokens.textfieldColorTextLabelDefault,
                    disabled: tokens.textfieldColorTextLabelDisabled,
                    error: tokens.textfieldColorTextLabelError
                },
                placeholder: {
                    default: tokens.textfieldColorTextPlaceholderDefault,
                    disabled: tokens.textfieldColorTextPlaceholderDisabled
                },
                helperText: {
                    default: tokens.textfieldColorTextHelperTextDefault,
                    disabled: tokens.textfieldColorTextHelperTextDisabled
                }
            }
        },
        containerless: {
            padding: tokens.selectContainerlessPadding,
            border: {
                radius: tokens.selectContainerlessRadius,
                width: tokens.selectContainerlessBorderWidth,
                default: tokens.selectContainerlessColorBorderDefault,
                hover: tokens.selectContainerlessColorBorderHover,
                focus: tokens.selectContainerlessColorBorderFocus,
                disabled: tokens.selectContainerlessColorBorderDisabled,
                error: tokens.selectContainerlessColorBorderError
            },
            background: {
                default: tokens.selectContainerlessColorBgDefault,
                hover: tokens.selectContainerlessColorBgHover,
                focus: tokens.selectContainerlessColorBgFocus,
                disabled: tokens.selectContainerlessColorBgDisabled,
                error: tokens.selectContainerlessColorBgError
            },
            text: {
                default: tokens.selectContainerlessColorTextDefault,
                disabled: tokens.selectContainerlessColorTextDisabled,
                error: tokens.selectContainerlessColorTextError
            }
        }
    };
};
export default selectPalette;
//# sourceMappingURL=select.js.map